export * from "./data-object-api";
export * from "./data-object-endpoints";
export * from "./data-object-client";
export * from "./types";

// This is a special tag from the backend that is set to help identify material runs that are not used as ingredients into other materials.
export const TERMINAL_MATERIAL_TAG = "citr_auto::terminal_material";

const INTERNAL_TAG_MASK = /^citr_auto::/;
export const userTagFilter = (tag: string) => !INTERNAL_TAG_MASK.test(tag);
